import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type { StAdjustmentTechnicianGroup } from "@/payroll/pay-breakdown/st-adjustments/types";

// How many of this technician's lines the next push will attempt.
//
// The period total only appears when it differs from that — i.e. when some lines
// have already landed, which is what a rerun that added lines after a push, or a
// push that partly failed, looks like. On a first push the two are always equal,
// and printing "26 of 26" on every row just reads as noise.
export const LINES_COLUMN: ColumnDef<StAdjustmentTechnicianGroup, unknown> = {
  id: "lines",
  header: "Pending lines",
  enableSorting: false,
  meta: { size: "10rem" },
  cell: ({ row }) => {
    const { pending, count } = row.original;

    return (
      <Stack direction="row" align="baseline" gap="xs" fullWidth>
        <Typography variant="bodyW1">{pending}</Typography>
        {pending !== count && (
          <Typography variant="bodyW2" textColor="secondary">
            of {count}
          </Typography>
        )}
      </Stack>
    );
  },
};
